import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-mot-detail-dialog',
  styleUrls: ['./mot-detail-dialog.component.scss'],
  templateUrl: 'mot-detail-dialog.component.html',
})
export class MotDetailDialogComponent {
  constructor(
    private matDialogRef: MatDialogRef<MotDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  handleClose() {
    this.matDialogRef.close({});
  }
}
